'use strict';

var minChars = 3;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsShadeWrapper(scope) {
    return $(scope).parents('.custom-shade-search').find('.suggestions-shade-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}


/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile span.';
    var iconSearch = 'icon-SEARCH';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose);
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch);
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}
function getSuggestionsVisualsWrapper() {
    return $('.suggestions-shade-details');
}

/**
 * Process Ajax response for SearchServices-GetSuggestionsShade
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponseShade(response) {
    var $suggestionsWrapper = getSuggestionsShadeWrapper(this).empty();
    var $suggestionsVisualWrapper = getSuggestionsVisualsWrapper(this).empty();
    $.spinner().stop();
    if (!(typeof (response) === 'object')) {
        var success = $($.parseHTML(response)).filter('.suggestions-content-details');
        $suggestionsWrapper.append(response).fadeIn();
        $suggestionsVisualWrapper.append(success.html());

        if ($('.skintone-action-revamp').length) {
            var sfvisualsVTO = $('.product-view-suggestion .sfvisualsVTO');

            $('.YMK-wrapper2').find('.suggestions-shade-details').empty().html(sfvisualsVTO.html());
        }


        positionSuggestions(this);
        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
        }
        $('#no-result-search').text($('.search-field').val());
        $('body').trigger('LoadSliderImages');
    } else {
        $suggestionsWrapper.fadeOut();
    }
    $('.custom-shade-search').show();
    $('#YMK-wrapper').focus();

    var buybutton = $('.aria-label-productLinktoShade-replace');
    if (buybutton.length) {
        $('.productLinktoShade-desktop.vto').empty().html(buybutton.html()).show();
    }

    var shadefindertitle = $('.shadefinder-title-replace');
    if (shadefindertitle && shadefindertitle.length > 0) {
        $('.pdp-title').empty().html(shadefindertitle.html()).show();
    }

    var title = $('.shade-name-tile-replace');
    if (title && title.length > 0) {
        $('.shade-name-tile').empty().html(title.html()).show();
    }

    var subtitle = $('.shadefinder-subtitle-replace');
    if (subtitle && subtitle.length > 0) {
        $('.pdp-subtitle').empty().html(subtitle.html()).show();
    }

    var imagereplace = $('.shadefinder-image-replace');
    if (imagereplace && imagereplace.length > 0) {
        $('.tile-image').attr('src', imagereplace.html());
    }

}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestionsShadeProduct(scope) {

    if ($(scope).attr('data-value').length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: $(scope).attr('data-url') + $(scope).attr('data-value'),
            method: 'GET',
            success: processResponseShade,
            error: function () {
                $.spinner().stop();
            }
        });
        $('.product-view-suggestion').removeClass('col-md-4').addClass('col-md-12');
    } else {
        toggleSuggestionsIcon('search');
        getSuggestionsShadeWrapper(scope).empty();
    }
}

module.exports = function () {
    $('.skintone-click1, .skintone-click2, .skintone-click3').on('click', function (event, a, b) {
        var isInter = $('input[name="inter"]');
        if (isInter.length === 0) {
            if ($(this).attr('data-shadeoos') === 'true') {
                var outOfStockValue = $('input[name="outOfStock"]').val().trim();
                if ($('.standalone-sephora').length) {
                    $('.standalone-sephora').replaceWith('<button type="button" class="standalone-sephora" disabled>' + outOfStockValue + '</button>')
                }
                if ($('.productLinktoShade-desktop.disabled').length) {
                    $('.productLinktoShade-desktop.disabled').empty().html(outOfStockValue).show();
                }
            } else {
                var addToCart2Value = $('input[name="addToCart2"]').val().trim();
                if ($('.standalone-sephora').length) {
                    $('.standalone-sephora').replaceWith('<button type="button" class="standalone-sephora">' + addToCart2Value + '</button>')
                }
                if ($('.productLinktoShade-desktop').length) {
                    $('.productLinktoShade-desktop').empty().html(addToCart2Value).show();
                }
            }
        }

        $(this).parents('.skintone-item').addClass('active').siblings('.skintone-item').removeClass('active');
        var $sephoraShadeFinderId = $('#sephora-shadefinder');
        var $iframeShadeFinder = $("#iframe-shadefinder");
        if ($('.skintone-click2').hasClass('click-first-button')) {
            var datalayername = $(this).siblings('.datalayer-name').text();
            var productName = $(".js_product-name").attr("data-product");
            var vtoSite = $(".gtmsite").attr("data-site");
            if (productName && vtoSite) {
                dataLayer.push({
                    'sf_type': 'Shade',
                    'sf_name': datalayername.toString().replace(/[^a-z0-9\s]/gi, '').trim(),
                    'sf_product_name': productName,
                    'sf_site_name': vtoSite,
                    'event': 'shade_finder_click'
                });
            }
        }
        $('.shadefinder-shadesquare').removeClass('active');
        $(this).find('svg').addClass('active');
        getSuggestionsShadeProduct($(this), b);
        if ($sephoraShadeFinderId.length > 0) {
            var sephoraURL = $(this).attr('data-url-sephora');
            $sephoraShadeFinderId.attr('data-url', sephoraURL);
        } else if ($iframeShadeFinder.length > 0) {
            var productUrl = $(this).attr('data-url-product');
            $iframeShadeFinder.attr('data-url', productUrl);
        }
        window.YMK.applyMakeupBySku($(this).attr('data-value'));
    });

    $('button.shade-circle-wrapper').each(function () {
        $(this).attr(
            'tabindex',
            $(this).hasClass('skintone-click2') ? '0' : '-1'
        );
        $(this).attr('role', 'radio');
    });

    $('button.shade-circle-wrapper').on('keydown', function (event) {
        var $skintoneCircle = $(this).closest('.skintone-circle');
        var $buttons = $skintoneCircle.find('.shade-circle-wrapper');
        var currentIndex = $buttons.index(this);
        var nextIndex, prevIndex;

        if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % $buttons.length;
            $buttons.eq(nextIndex).attr('tabindex', '0').focus().click();
            $(this).attr('tabindex', '-1');
        } else if (event.key === 'ArrowLeft') {
            prevIndex = (currentIndex - 1 + $buttons.length) % $buttons.length;
            $buttons.eq(prevIndex).attr('tabindex', '0').focus().click();
            $(this).attr('tabindex', '-1');
        }
    });

    $('#mascarapro-wrapper-sephora .shadefinder-shadesquare, #virtualtry-wrapper .landing-rouge-shade-interact-module-shade-svg path, #virtualtry-wrapper-sephora .landing-rouge-shade-interact-module-shade-svg path, #virtualtry-wrapper .shadefinder-shadesquare, #virtualtry-wrapper-sephora .shadefinder-shadesquare, #virtualtry-wrapper-asia .shadefinder-shadesquare, #virtualtry-wrapper-raso .shadefinder-shadesquare').on('click', function (event, a, b) {
        if (!($(this).hasClass('disabledshade'))) {
            if ($('.landing-rouge-shade-interact-module-shade-svg').hasClass('click-first-button')) {
                var datalayername = $(this).attr('aria-label');
                dataLayer.push({
                    'sf_type': 'Shade',
                    'sf_name': datalayername,
                    'event': 'red_shade_click'
                });
            } else {
                $('.landing-rouge-shade-interact-module-shade-svg').addClass('click-first-button');
            }
            if ($("#virtualtry-wrapper-sephora").length > 0) {
                var sephoraURL = $(this).attr('data-url-sephora');
                $('#virtualtry-wrapper-sephora').attr('data-url-sephora', sephoraURL);
            }
            if ($("#virtualtry-wrapper-asia").length > 0) {
                var siteUrl = $(this).attr('data-url-site');
                $('#virtualtry-wrapper-asia').attr('data-url-site', siteUrl);
            }
            if ($("#mascarapro-wrapper-sephora").length > 0) {
                var sephoramascaraURL = $(this).attr('data-url-sephora');
                $('#mascarapro-wrapper-sephora').attr('data-url-sephora', sephoramascaraURL);
            }
            $('.landing-rouge-shade-interact-module-shade-groupname').removeClass('active');
            $(this).closest('.landing-rouge-shade-interact-module-shade-svgcontainer').find('.landing-rouge-shade-interact-module-shade-groupname').addClass('active');
            $('.landing-rouge-shade-interact-module-shade-svg path').removeClass('active');
            $('#aquaresist-wrapper .landing-rouge-shade-interact-module-shade, #mascarapro-wrapper .landing-rouge-shade-interact-module-shade').removeClass('active');
            $('.landing-rouge-shade-interact-module-shade.vto-sephora .shadefinder-shadesquare').removeClass('active');
            $('.landing-rouge-shade-interact-module-shade.vto-rougeartist .shadefinder-shadesquare').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.landing-rouge-shade-interact-module-shade-svgcontainer').addClass('active');
            $("html, body").animate({ scrollTop: 150 }, 1000);
            getSuggestionsShadeProduct($(this), b);
            window.YMK.reset()
            window.YMK.applyMakeupBySku($(this).attr('data-value'));
        }
    });

    $('#aquaresist-wrapper .shadefinder-shadesquare, #mascarapro-wrapper .shadefinder-shadesquare').on('click', function (event, a, b) {
        if (!($(this).hasClass('disabledshade'))) {
            if ($('.landing-rouge-shade-interact-module-shade-svg:first-child').hasClass('click-first-button')) {
                var datalayername = $(this).attr('aria-label');
                dataLayer.push({
                    'sf_type': 'Shade',
                    'sf_name': datalayername,
                    'event': 'red_shade_click'
                });
            } else {
                $('.landing-rouge-shade-interact-module-shade-svg:first-child').addClass('click-first-button');
            }
            $('#aquaresist-wrapper .shadefinder-shadesquare, #mascarapro-wrapper .shadefinder-shadesquare').removeClass('active');
            if ($('#sephora-aquaresist').length > 0) {
                var sephoraURL = $(this).attr('data-url-sephora');
                $('#sephora-aquaresist').attr('data-url-sephora', sephoraURL);
            }
            $(this).addClass('active');
            getSuggestionsShadeProduct($(this), b);
            window.YMK.reset()
            window.YMK.applyMakeupBySku($(this).attr('data-value'));
            $('.shade-name-tile').css('color', $(this).attr('fill'));
        }
    });

    /**
     * Event triggered when customer press enter on a colored shade
     */
    $('.landing-rouge-shade-interact-module-shade-svg path').on('keypress', function (e) {
        if (e.which == 13) {
            $(this).trigger('click');
        }
    });

    $('.sr-only-focus a').click(function (e) {
        e.preventDefault();
        var linktofocus = $(this).attr('href');
        if ($(this).hasClass('skip-color-picker')) {
            $(linktofocus).focus();
        } else {
            $(linktofocus).find('path:first-child').focus();
        }
    });
    $(document).on('touchstart click', '.standalone-sephora', function () {
        if ($('#sephora-shadefinder').length) {
            var url = $('#sephora-shadefinder').attr('data-url');
            window.location.href = url;
        } else {
            $('.productLinkto.productLinktoShade-desktop').click();
        }
    });
};
